import { render, staticRenderFns } from "./studentGroup.vue?vue&type=template&id=1aa0040f"
import script from "./studentGroup.vue?vue&type=script&lang=js"
export * from "./studentGroup.vue?vue&type=script&lang=js"
import style0 from "./studentGroup.vue?vue&type=style&index=0&id=1aa0040f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports